import { Component, DestroyRef, inject, Inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { faCheck, faFileLines, faMinus, faPlus, faSlidersH, faXmark } from '@fortawesome/free-solid-svg-icons';
import { ErrorService } from '../../../../../../@core/utils/error.service';
import { lotInventory } from '../../../../laboratory/services/lab-quantity-service';
import { InventoryService } from '../../../../pick-plan/services/inventory.service';
import { ReasonCode } from '../../../models/reason-code';

export interface LotAdjustData extends lotInventory {
  lotNumber?: string;
}

/** Adjusts a lot's quantity up or down. Closes with the edited copy; the caller works out add vs remove. */
@Component({
  selector: 'lot-details-by-room-dialog',
  templateUrl: './lot-details-by-room-dialog.component.html',
  styleUrls: ['./lot-details-by-room-dialog.component.scss']
})
export class LotDetailsByRoomDialogComponent implements OnInit {

  static open(dialog: MatDialog, data: LotAdjustData): MatDialogRef<LotDetailsByRoomDialogComponent, lotInventory> {
    return dialog.open(LotDetailsByRoomDialogComponent, { data, width: '560px', maxWidth: '95vw' });
  }

  public faCheck = faCheck;
  public faFileLines = faFileLines;
  public faMinus = faMinus;
  public faPlus = faPlus;
  public faSlidersH = faSlidersH;
  public faXmark = faXmark;

  public quantityEdit: number = null;
  /** A copy, so cancelling leaves the caller's row untouched. */
  public lotInventoryItem: LotAdjustData;
  public reasonCodes: ReasonCode[] = [];
  private destroyRef = inject(DestroyRef);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: LotAdjustData,
    private inventoryService: InventoryService,
    private errorService: ErrorService,
    public dialogRef: MatDialogRef<LotDetailsByRoomDialogComponent, lotInventory>,
  ) {
    this.lotInventoryItem = { ...data };
  }

  ngOnInit() {
    this.inventoryService.getReasonCodes().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: x => this.reasonCodes = x ?? [],
      error: err => this.errorService.handleError(err)
    });
  }

  get change(): number {
    return (this.lotInventoryItem.quantity ?? 0) - (this.lotInventoryItem.originalQuantity ?? 0);
  }

  get canSave(): boolean {
    return this.change !== 0 && !!this.lotInventoryItem.reasonCodeId;
  }

  add() {
    this.lotInventoryItem.quantity += this.quantityEdit ?? 0;
  }

  remove() {
    this.lotInventoryItem.quantity -= this.quantityEdit ?? 0;
  }

  submit() {
    if (this.canSave)
      this.dialogRef.close(this.lotInventoryItem);
  }

  cancel() {
    this.dialogRef.close();
  }
}
